<template>
  <tr
    :id="id"
    :key="id"
    :class="{ 'ecs-table-row__draggable': !!id, primary: !id, 'white--text': !id }"
    @contextmenu="contextMenu($event, row.item)"
  >
    <td v-for="header in row.headers" :key="header.value">
      <EcsTableCell
        :agent-name="row.item['agentName']"
        :width="header.width"
        :header="header"
        :value="row.item[header.value]"
        :now="now"
        :app-time-zone-id="appTimeZoneId"
      />
    </td>
  </tr>
</template>

<script>
import EcsTableCell from '@/components/ecs-table/EcsTableCell';
export default {
  name: 'EcsTableRow',
  components: { EcsTableCell },
  props: {
    row: {
      type: Object,
      required: true
    },
    idField: {
      type: String,
      required: true
    },
    contextMenuEvent: {
      type: String,
      default: ''
    },
    now: {
      type: Object,
      required: true
    },
    appTimeZoneId: {
      type: String,
      required: true
    }
  },
  computed: {
    id() {
      return this.row.item[this.idField];
    }
  },
  methods: {
    contextMenu(event, item) {
      const root = this.$root;
      if (this.contextMenuEvent) {
        event.preventDefault();
        root.$emit(this.contextMenuEvent, event, item);
      }
    }
  }
};
</script>

<style scoped>
tr {
  transform: unset !important;
}
</style>

<style>
td:has(.highlight) {
  background: linear-gradient(var(--v-primary-lighten1), var(--v-primary-lighten1));
  background-size: calc(100% - 2) calc(100% - 2);
  background-repeat: no-repeat;
  background-position: center;
  color: white;
}

[dark] td:has(.highlight) {
  color: black;
}
</style>
